import Nullstack from 'nullstack';
export default function IconScale({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-scale",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "20",
    x2: "17",
    y2: "20"
  }), "   ", Nullstack.element("path", {
    d: "M6 6l6 -1l6 1"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "3",
    x2: "12",
    y2: "20"
  }), "   ", Nullstack.element("path", {
    d: "M9 12l-3 -6l-3 6a3 3 0 0 0 6 0"
  }), "   ", Nullstack.element("path", {
    d: "M21 12l-3 -6l-3 6a3 3 0 0 0 6 0"
  }), " ");
}